var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7501 22C13.1297 22 14.2489 20.8809 14.2489 19.5H9.25122C9.25122 20.8809 10.3704 22 11.7501 22ZM20.1637 16.152C19.409 15.341 17.9969 14.1211 17.9969 10.125C17.9969 7.08984 15.8688 4.66016 12.9993 4.06406V3.25C12.9993 2.55977 12.4399 2 11.7501 2C11.0602 2 10.5008 2.55977 10.5008 3.25V4.06406C7.6313 4.66016 5.50318 7.08984 5.50318 10.125C5.50318 14.1211 4.09107 15.341 3.33638 16.152C3.10201 16.4039 2.9981 16.7051 3.00003 17C3.00435 17.6406 3.50708 18.25 4.25396 18.25H19.2461C19.993 18.25 20.4961 17.6406 20.5001 17C20.502 16.7051 20.3981 16.4035 20.1637 16.152Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.807d952ac406508b8e853e513b682907.svg";
export { ForwardRef as ReactComponent };